import React from 'react';

import ElementConstants from '../../../../shared/constants/elements';

import InputLabel from '../../widgets/input-label';
import InputHint from '../../widgets/input-hint';
import Localization from '../../../../../../../common/edlio-js/models/BackendLocalization';

export default class FileUploadElement extends React.Component {
	render() {
		const {
			fieldsetIndex,
			rowIndex,
			index,
			usePlaceholderLabel
		} = this.props;

		const {
			label,
			hint,
			attributes,
			required
		} = this.props.data;

		let localization = new Localization(window.edlio.localizations);

		return (
			<div className='file-upload input'>
				<header>
					<InputLabel ref='label' label={label} required={required} usePlaceholderLabel={usePlaceholderLabel} />
					<InputHint ref='hint' hint={hint} />
				</header>
				<div className='bin'>
					{localization.localize('They can upload or drop their file(s) here')}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/inputs/file-upload.js